// extracted by mini-css-extract-plugin
module.exports = {"divider":"_2nn9R___Divider-module__divider"};